module.exports = function anonymous(it
/**/) {
var out='<figure class="overlay--gallery__item" data-id="'+(it.id)+'"> <div data-load></div> <figcaption> <span class="overlay--gallery__item__caption">'+(it.Caption)+'</span> ';if(it.Image && it.Image.Size){out+=' <a href="mailto:communications@petrofac.com?subject=Image Request&amp;body='+(it.Image.Src)+'" class="overlay--gallery__item__request">Request image ('+(it.Image.Size)+')</a> ';}out+=' </figcaption></figure>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/templates/galleryItem.dot
 ** module id = 234
 ** module chunks = 0 1
 **/